import { render, staticRenderFns } from "./DashboardDebts.vue?vue&type=template&id=23040a72&"
import script from "./DashboardDebts.vue?vue&type=script&lang=js&"
export * from "./DashboardDebts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports